/**
 * {
 *   success: true,
 *   visitor_uuid: "f627ee608adb01315d1022000ab2058a",
 *   anonymous: false,
 *   email: "john@acme.com",
 *   custom_fields: { "name": "John" },
 *   tags: ["Customer"],
 *   lead_score: 35
 * }
 */

const DRIP_ACTIVE = true;

export type DripParams = {
  [string]: mixed
}

export type DripPayload = {
  success: boolean,
  visitor_uuid: string,
  anonymous: boolean,
  email: string,
  custom_fields: { [string]: mixed },
  tags: Array<string>,
  lead_score: number
}

function dripDebug(method, ...params) {
  // eslint-disable-next-line
  console.debug(`[DRIP: ${method}]`, params);
}

export function identify(params: DripParams = {}) {
  return new Promise(function (resolve, reject) {
    if (!DRIP_ACTIVE) {
      dripDebug('identify', params);
      return resolve();
    }

    window._dcq.push(['identify', {
      ...params,
      success: function (response) {
        resolve(response);
      },
      failure: function (response) {
        reject(response);
      }
    }]);
  });
}

export function persistLocal(visitor: DripPayload, bypass: boolean = true) {
  // console.log('persistLocal', visitor, bypass);

  if (!visitor ||
      !visitor.hasOwnProperty('visitor_uuid') ||
      !visitor.hasOwnProperty('email')) {
    return;
  }

  if (!window.Modernizr.localstorage) {
    return;
  }

  localStorage.setItem('email', visitor.email);
  localStorage.setItem('uuid', visitor.visitor_uuid);

  if (bypass) {
    localStorage.setItem('bypass', 'true');
  }
}

export function track(event: string, params: DripParams = {}) {
  return new Promise(function (resolve, reject) {
    if (!DRIP_ACTIVE) {
      dripDebug('track', event, params);
      return resolve();
    }

    window._dcq.push(['track', event, {
      ...params,
      success: function (response) {
        resolve(response);
      },
      failure: function (response) {
        reject(response);
      }
    }]);
  });
}



// WEBPACK FOOTER //
// ./src/utils/drip.js